<div class="diagnostics-start">
  <div class="vm-container">
    <div class="diagnostics-start__heading">
      <div class="vm-row">
        <div class="vm-col-xs-12">
          <vm-page-heading [routerLinkText]="backLabel" [isDefault]="true" vmRemoveFromView></vm-page-heading>
        </div>
      </div>
    </div>
  </div>

  <div class="vm-container cozy">
    <div class="diagnostics-start__content">
      <div class="vm-col-xs-12">
        <vm-confirmation
          [icon]="content?.icon"
          [iconColor]="content?.iconColor"
          [iconWeight]="content?.iconWeight"
          [title]="content?.title"
          [info]="content?.info"
          [nextActions]="content?.actions"
          [extraInfo]="content?.extraInfo"
          [secondaryModalLabel]="content?.secondaryModalLabel"
          [secondaryModalCopy]="content?.secondaryModalCopy"
          [tertiaryModalLabel]="content?.tertiaryModalLabel"
          [tertiaryModalTitle]="content?.tertiaryModalTitle"
          [tertiaryModalCopy]="content?.tertiaryModalCopy"
          [chatbotId]="content?.chatbotId || 'faultsbuttonnew'">
          <vm-generic-tiles
            class="confirmation__before-actions"
            [tiles]="content?.tiles"
            columnView="two-column"
            (selected)="onTileClick($event)">
          </vm-generic-tiles>
        </vm-confirmation>
      </div>
    </div>
  </div>
</div>
